import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const before = ['Searching five websites for one project', 'Writing rubrics from scratch', 'Building visual references every time', 'No plan when students finish early'];
const after = ['Open the volume, pick the lesson, teach', 'Rubrics and reflection pages ready to print', 'Classroom visuals ready to display', '10-minute activities for any gap'];
export function PainSection() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-131" data-mp="2pz2k7n8f15u9">
      <div className="mx-auto max-w-5xl" data-id="element-132" data-mp="2q0dkve6kdxh5">
        <div className="mx-auto max-w-2xl text-center" data-id="element-133" data-mp="2bag4hkevmc2i">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-134" data-mp="2bbzkrb0j8n4a">
            Planning one Art lesson shouldn&apos;t take an hour of searching.
          </h2>
          <p className="mt-3 text-sm italic text-gold sm:text-base" data-id="element-135" data-mp="22a03chllvh0t">
            The problem isn&apos;t a lack of resources. It&apos;s that they&apos;re scattered.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-2" data-id="element-136" data-mp="3rlpp3hqvfgeh">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-red-400 bg-maroon p-6 sm:p-8" data-id="element-137" data-mp="3nm75cpasdbd8">
            <h3 className="mb-5 text-lg font-bold text-white sm:text-xl" data-id="element-138" data-mp="33xgaazs2rswu">
              Without a system
            </h3>
            <PainList items={before} icon="x" data-id="element-139" data-mp="3imul8cbauiec" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-gold bg-navy-mid p-6 sm:p-8" data-id="element-140" data-mp="3io5pseckju6i">
            <h3 className="mb-5 text-lg font-bold text-gold sm:text-xl" data-id="element-141" data-mp="p1poz5dmbw4v">
              With THE COMPLETE ART YEAR™
            </h3>
            <PainList items={after} icon="check" data-id="element-142" data-mp="yt3m56i3kjuu" />
          </motion.div>
        </div>
      </div>
    </section>;
}
function PainList({
  items,
  icon
}: {
  items: string[];
  icon: 'x' | 'check';
}) {
  const Icon = icon === 'x' ? XIcon : CheckIcon;
  return <ul className="space-y-3" data-id="element-143" data-mp="66spg6xm333b">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-144" data-mp="b399oq1owxb4">
          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${icon === 'x' ? 'bg-red-500/20 text-red-300' : 'bg-gold/15 text-gold'}`} data-id="element-145" data-mp="b5vtbo1uv39p">
            <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-146" data-mp="k6afepmn8me9" />
          </span>
          <span className="text-sm leading-relaxed text-white/85" data-id="element-147" data-mp="1qjrnaijrtp8i">{item}</span>
        </li>)}
    </ul>;
}